import { createSelector } from 'reselect';
import { GalleryState } from './types';

export const gallerySelector = (state): GalleryState['templates'] => state.gallery.templates;
export const selectedGalleryIdSelector = (state): GalleryState['selectedTemplateId'] =>
    state.gallery.selectedTemplateId;

export const selectedGallerySelector = createSelector(
    gallerySelector,
    selectedGalleryIdSelector,
    (templates, selectedTemplateId) => {
        return templates.find((template) => template.id === selectedTemplateId);
    },
);
